// Autogenerated with: yarn tsx scripts/generateSvgInfo.ts
// To make changes to this file, edit that script.
// To resolve merge conflicts in this file, simply re-run that script.
// This script is also run by `yarn codegen`.

import { type SvgNameCustomizable } from './_generatedSvgTypes';

export const SVGNAME_TO_DIMENSIONS_MAP_CUSTOMIZABLE: Record<
  SvgNameCustomizable,
  { width: number; height: number }
> = {
  ArrowRightCustomizable: { width: 48, height: 49 },
  ArrowUpCustomizable: { width: 48, height: 100 },
  CloseCustomizable: { width: 32, height: 32 },
  'Coordinates/CirclePointCustomizable': { width: 36, height: 36 },
  'Coordinates/CirclePointBorderedCustomizable': { width: 38, height: 38 },
  'Coordinates/CrossPointCustomizable': { width: 36, height: 36 },
  'Coordinates/FilledSquarePointCustomizable': { width: 36, height: 36 },
  'Coordinates/SquarePointCustomizable': { width: 36, height: 36 },
  'Coordinates/TrianglePointCustomizable': { width: 36, height: 36 },
  CounterCustomizable: { width: 300, height: 300 },
  SliderArrowCustomizable: { width: 26, height: 111 },
  SliderArrowRightCustomizable: { width: 111, height: 26 },
  SquareCustomizable: { width: 100, height: 100 },
  'zest/rotate-leftCustomizable': { width: 38, height: 43 }
};
